export { default as AnalisisSolidoVer } from './Ver';
export { default as LaboratorioSolidoEditar } from './Editar';
export { default as LaboratorioSolidoListar } from './Listar';
export { default as PendientesSolidoValidar } from './PendientesValidacion';
export { default as HistoricoAnalisisSolido } from './Historico';
